import React from 'react'
import { discountLabel, money, orderFinancials } from './orderFinancials'

const amount = cents => cents === null ? 'No registrado' : `MXN $${(cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

const FinancialBreakdown = ({ order }) => {
    const financials = orderFinancials(order)
    const { subtotal, discount, shipping, tax, total, details, unexplained, detailMismatch, carrierCostStatus, carrierCost, shippingContribution } = financials
    return (
        <section className="order-financial-breakdown" aria-label="Desglose financiero del pedido">
            <h4>Desglose del pedido</h4>
            <table className="table table-sm">
                <tbody>
                    <tr><th>Subtotal antes de descuentos</th><td>{amount(subtotal)}</td></tr>
                    <tr><th>Descuento(s) aplicado(s)</th><td>{discount === null ? 'No registrado' : `${discount > 0 ? '−' : ''}${amount(discount)}`}</td></tr>
                    <tr><th>Envío cobrado al cliente</th><td>{amount(shipping)}</td></tr>
                    {tax !== null && tax !== 0 && <tr><th>Impuestos registrados</th><td>{amount(tax)}</td></tr>}
                    {unexplained !== null && unexplained !== 0 && <tr><th>Diferencia sin desglose registrado</th><td>{amount(unexplained)}</td></tr>}
                    <tr><th>Total del pedido</th><td><strong>{amount(total)}</strong></td></tr>
                </tbody>
            </table>
            {details.length > 0 && (
                <div>
                    <strong>Detalle de descuentos (incluido arriba)</strong>
                    <ul>{details.map((detail, index) => <li key={index}>{discountLabel(detail, order.couponCode)}: {amount(money(detail.amount))}</li>)}</ul>
                </div>
            )}
            {order.couponCode && !details.some(detail => detail.type === 'code' || detail.code === order.couponCode) && <p>Código registrado: {order.couponCode}</p>}
            {detailMismatch && <p>El detalle de promociones disponible no coincide con el descuento registrado. Se conserva el importe histórico del pedido.</p>}
            {unexplained === null && <p>Faltan datos históricos para conciliar el desglose. Se muestra el total registrado sin recalcularlo.</p>}
            {unexplained !== null && unexplained !== 0 && <p>La diferencia no identifica un cargo de envío ni otro ajuste específico. Se conserva el total registrado.</p>}
            <h4>Costos internos de envío</h4>
            <table className="table table-sm">
                <tbody>
                    <tr><th>Envío cobrado al cliente</th><td>{amount(shipping)}</td></tr>
                    <tr><th>Costo real de paquetería / guía</th><td>{carrierCost === null ? carrierCostStatus : amount(carrierCost)}</td></tr>
                    <tr><th>Contribución de envío</th><td>{shippingContribution === null ? (shipping === null ? 'No registrado' : carrierCostStatus) : amount(shippingContribution)}</td></tr>
                </tbody>
            </table>
            <p>La cotización de envío no confirma el costo real de la guía. La contribución requiere ambos importes registrados.</p>
        </section>
    )
}

export default FinancialBreakdown
